import { } from '@/api/requests';
import router from '../../router';

const state = {
  waitingFeedback: [],
  approvedFeedback: [],
  rejectedFeedback: [],
};

const mutations = {
  removeFrom(state, payload) {
    let index = state[payload.type].indexOf(payload.value);
    state[payload.type].splice(index, 1);
  },

  addTo(state, payload) {
    state[payload.type].unshift(payload.value)
  },

  setOriginalValue(state, payload) {
    state[payload.type] = payload.value
  },

  loadMore(state, payload) {
    state[payload.type] = state[payload.type].concat(payload.value);
  }
};

const actions = {

};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};